import ShopOutlined from '@ant-design/icons/ShopOutlined';
import GiftOutlined from '@ant-design/icons/GiftOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import DashboardOutlined from '@ant-design/icons/DashboardOutlined';
import ApartmentOutlined from '@ant-design/icons/ApartmentOutlined';
import CalendarOutlined from '@ant-design/icons/CalendarOutlined';
import { t } from 'i18n';

const restaurants = {
  id: 'group-restaurants',
  title: t('Restaurants'),
  type: 'group',
  children: [
    { id: 'restaurants-list', title: t('Restaurants'), type: 'item', url: '/restaurants', icon: ShopOutlined },
    { id: 'restaurant-brands', title: t('Restaurant Brands'), type: 'item', url: '/restaurants/brands', icon: ApartmentOutlined },
    { id: 'bundles', title: t('Bundles'), type: 'item', url: '/restaurants/bundles', icon: GiftOutlined },
    { id: 'subscriptions', title: t('Subscriptions'), type: 'item', url: '/restaurants/subscriptions', icon: CalendarOutlined },
    { id: 'bundle-status', title: t('Bundle Status'), type: 'item', url: '/restaurants/bundle-status', icon: DashboardOutlined },
    { id: 'fees', title: t('Delivery Fees'), type: 'item', url: '/restaurants/fees', icon: DollarOutlined }
  ]
};

export default restaurants;
